import MenuSpy from "menuspy";

export function showMenu() {
	document.addEventListener("DOMContentLoaded", function () {
		const barBtn = document.querySelector(".header-bar");
		const menu = document.querySelector(".header-nav-mobile");
		const overlay = document.querySelector(".overlay");

		// MenuSpy initialization
		$(document).ready(function () {
			const nav = document.querySelector("[data-menuspy-nav]");
			if (nav) {
				const ms = new MenuSpy(nav, {
					menuItemSelector: "[data-menuspy-item]",
					activeClass: "active",
					threshold: 15,
					enableLocationHash: false,
					hashTimeout: 600,
					offset: 120, // Điều chỉnh offset này tùy theo chiều cao của header
					callback: function (element) {
						// Remove active class from all items
						$("[data-menuspy-item]").removeClass("active");
						// Add active class to current element
						if (element) {
							$(element).addClass("active");
						}
					},
				});
			}

			// Smooth scroll
			$("[data-menuspy-item]").on("click", function (e) {
				e.preventDefault();
				const target = $($(this).attr("href"));

				if (target.length) {
					$("html, body").animate(
						{
							scrollTop: target.offset().top - 120, // Điều chỉnh offset này tùy theo chiều cao của header
						},
						500
					);
				}
			});

			// Initialize MenuSpy for both service nav and about tabs
			const initMenuSpy = (navElement, options) => {
				if (navElement) {
					return new MenuSpy(navElement, options);
				}
			};

			// About Tabs MenuSpy
			const tabsNav = document.querySelector(".tabs");
			initMenuSpy(tabsNav, {
				menuItemSelector: ".tab-button",
				activeClass: "active",
				threshold: 15,
				enableLocationHash: false,
				hashTimeout: 600,
				offset: 100,
				callback: function (element) {
					// Remove active from all tabs
					const allTabs = document.querySelectorAll(".tab-button");
					allTabs.forEach((tab) => tab.classList.remove("active"));

					if (element) {
						element.classList.add("active");
					}
				},
			});

			// Service Navigation MenuSpy (giữ nguyên phần này)
			const serviceNav = document.querySelector(".service-2-nav");
			initMenuSpy(serviceNav, {
				menuItemSelector: ".service-2-menu li a",
				activeClass: "active",
				threshold: 15,
				enableLocationHash: true,
				hashTimeout: 600,
				offset: 100,
				callback: function (element) {
					const allLinks = document.querySelectorAll(".service-2-menu li a");
					allLinks.forEach((link) => link.classList.remove("active"));
					if (element) {
						element.classList.add("active");
						const sectionId = element.getAttribute("href");
						history.replaceState(null, null, sectionId);
					}
				},
			});

			// Smooth scroll for service navigation
			$(".service-2-menu li a").on("click", function (e) {
				e.preventDefault();

				// Remove active class from all links
				$(".service-2-menu li a").removeClass("active");
				// Add active class to clicked link
				$(this).addClass("active");

				const target = $($(this).attr("href"));
				if (target.length) {
					$("html, body").animate(
						{
							scrollTop: target.offset().top - 100, // Adjust offset based on header height
						},
						500,
						function () {
							// Update URL hash after scroll animation completes
							const hash = $(target).attr("id");
							history.replaceState(null, null, `#${hash}`);
						}
					);
				}
			});
		});

		if (barBtn && menu && overlay) {
			barBtn.addEventListener("click", () => {
				menu.classList.toggle("open");
				overlay.classList.toggle("is-show");

				const icon = barBtn.querySelector("i");
				if (menu.classList.contains("open")) {
					icon.classList.remove("fa-bars");
					icon.classList.add("fa-times");
				} else {
					icon.classList.remove("fa-times");
					icon.classList.add("fa-bars");
				}
			});
		}

		// Search
		const searchBtns = document.querySelectorAll(".header-search");
		const searchBar = document.querySelector(".search-bar-container");

		if (searchBtns && searchBar) {
			searchBtns.forEach((btn) => {
				btn.addEventListener("click", function () {
					searchBar.classList.toggle("active");

					const icon = btn.querySelector("i");
					if (searchBar.classList.contains("active")) {
						icon.classList.remove("fa-magnifying-glass");
						icon.classList.add("fa-times");
					} else {
						icon.classList.remove("fa-times");
						icon.classList.add("fa-magnifying-glass");
					}
				});
			});
		}
	});
}

showMenu();
